import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { cn } from '../../lib/utils';

export function KPICard({ 
  title, 
  value, 
  change, 
  changeType = 'neutral', 
  icon: Icon,
  description,
  className,
  index = 0 
}) {
  const getTrendIcon = () => {
    if (changeType === 'positive') return TrendingUp;
    if (changeType === 'negative') return TrendingDown;
    return Minus;
  };
  
  const getTrendColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-destructive';
    return 'text-muted-foreground';
  };
  
  const TrendIcon = getTrendIcon();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: index * 0.05 }}
      className={cn('kpi-card group', className)}
    >
      <div className="flex items-start justify-between mb-3">
        <div className={cn(
          'w-10 h-10 rounded-xl flex items-center justify-center transition-transform duration-200 group-hover:scale-105',
          'bg-primary-light'
        )}>
          {Icon && <Icon className="w-5 h-5 text-primary" />}
        </div>
        {change && (
          <div className={cn('flex items-center gap-1 text-sm font-medium', getTrendColor())}>
            <TrendIcon className="w-4 h-4" />
            <span>{change}</span>
          </div>
        )}
      </div>
      
      <div>
        <p className="text-sm text-muted-foreground mb-1">{title}</p>
        <p className="text-2xl font-display font-bold text-foreground">{value}</p>
        {description && (
          <p className="text-xs text-muted-foreground mt-1">{description}</p>
        )}
      </div>
    </motion.div>
  );
}

export function KPICardSmall({ title, value, icon: Icon, variant = 'default' }) {
  const getVariantStyles = () => {
    switch (variant) {
      case 'success':
        return 'bg-success-light text-success';
      case 'warning':
        return 'bg-warning-light text-warning';
      case 'danger':
        return 'bg-primary-light text-primary';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  return (
    <div className="flex items-center gap-3 p-3 rounded-lg bg-card border border-border">
      <div className={cn('w-8 h-8 rounded-lg flex items-center justify-center', getVariantStyles())}>
        {Icon && <Icon className="w-4 h-4" />}
      </div>
      <div>
        <p className="text-xs text-muted-foreground">{title}</p>
        <p className="text-sm font-semibold text-foreground">{value}</p>
      </div>
    </div>
  );
}
